import React from 'react';
import { Box, Flex, Text, Icon } from '@chakra-ui/react';
import { FiNavigation } from 'react-icons/fi';

const PulseLoading = () => (
    <Flex
        position="fixed"
        top="0"
        left="0"
        right="0"
        bottom="0"
        bg="rgba(255,255,255,0.95)"
        zIndex="9999"
        justify="center"
        align="center"
        flexDirection="column"
    >
        <Box
            animation="pulse 2s infinite"
            bg="brand.500"
            color="white"
            p={6}
            borderRadius="full"
            boxShadow="lg"
            mb={4}
            sx={{
                '@keyframes pulse': {
                    '0%': { transform: 'scale(0.95)', boxShadow: '0 0 0 0 rgba(66, 153, 225, 0.7)' },
                    '70%': { transform: 'scale(1.05)', boxShadow: '0 0 0 20px rgba(66, 153, 225, 0)' },
                    '100%': { transform: 'scale(0.95)', boxShadow: '0 0 0 0 rgba(66, 153, 225, 0)' }
                }
            }}
        >
            <Icon as={FiNavigation} boxSize={12} />
        </Box>
        <Text fontSize="lg" fontWeight="bold" color="brand.800">
            正在連線校園系統...
        </Text>
        <Text fontSize="sm" color="gray.500" mt={2}>GPS 定位中</Text>
    </Flex>
);

export default PulseLoading;
